module.exports = __webpack_public_path__ + "static/media/icon-ticket.5ba770c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-ticket.svg
// module id = 2578
// module chunks = 0